import { Routes } from '@angular/router';
import { ApplicationGuard } from './modules/usermgmt/guards/application.guard';
import { CanDeactivateGuard } from './modules/usermgmt/guards/can-deactivate.guard';



export const routes: Routes = [
    { path: '', redirectTo: 'landing', pathMatch: 'full' }, // Default route
    {
        path: 'landing',
        canActivate: [ApplicationGuard],
        data: { resource: 'Home' },
        loadComponent: () => import('./components/landing/landing.component').then((m) => m.LandingComponent),
    },
    {
        path: 'zone-rules',
        canActivate: [ApplicationGuard],
        data: { resource: 'Home' },
        loadComponent: () => import('./components/zone-rules/zone-rules.component').then((m) => m.ZoneRulesComponent),
    },
    {
        path: 'stationInfo',
        canActivate: [ApplicationGuard],
        canDeactivate: [CanDeactivateGuard],
        data: {
            resource: 'Home',
            preload: true
        },
        loadComponent: () =>
            import('./stationData/station-info/station-info.component')
                .then(m => m.StationInfoComponent),
    },
    {
        path: 'versions',
        canActivate: [ApplicationGuard],
        data: { resource: 'Home' },
        loadComponent: () => import('./components/archived-versions/archived-versions.component').then((m) => m.ArchivedVersionsComponent),

    },
    {
        path: 'addStation',
        canActivate: [ApplicationGuard],
        data: { resource: 'Home' },
        loadComponent: () => import('./components/survey-stepper/survey-stepper.component').then((m) => m.SurveyStepperComponent),
    },
    {
        path: 'access-denied',
        loadComponent: () =>
            import('./pages/no-application-access/no-application-access.component').then(
                (mod) => mod.NoApplicationAccessComponent
            ),
    },
    {
        path: 'landing/launch',
        loadComponent: () => import('./components/landing/landing.component').then((m) => m.LandingComponent),
    },
    {
        path: 'usermgmt',
        canActivate: [ApplicationGuard],
        data: { resource: 'User Management' },
        loadChildren: () =>
            import('usermgmt').then((m) => m.userMgmtRoutes)
    },
    {
        path: 'major-change-access',
        canActivate: [ApplicationGuard],
        data: { resource: 'Home' },
        loadComponent: () => import('./components/major-change-access/major-change-access.component').then((m) => m.MajorChangeAccessComponent),
    },
    { path: '**', redirectTo: 'landing' },

];
